import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import { icon, iconify } from 'src/components/icons/icons';

// ----------------------------------------------------------------------

/*
const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const iconify = (name: string) => (
  <Iconify icon={name} width={32} />
);
*/

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  audience: icon('ic_audience'),
  document: icon('ic_documents'),
  clock: icon('ic_clock'),
  group: icon('ic_group'),
  admin: icon('ic_admin'),
  module: icon('ic_block'),
  email: icon('ic_email'),
  logs: icon('ic_logs'),
  license: icon('ic_license'),
  registration: icon('ic_ticket'),
  users: iconify('fluent:person-24-filled'),
};

// ----------------------------------------------------------------------


export function useNavData() {
  const data = useMemo(
    () => [
      // ----------------------------------------------------------------------
      // Admin
      // ----------------------------------------------------------------------
      {
        subheader: '',
        items: [
          { title: 'Dashboard', path: paths.dashboard.root, icon: ICONS.analytics },
          { title: 'Tenants', path: paths.dashboard.tenants.root, icon: ICONS.group },
          { title: 'Modules', path: paths.dashboard.modules.root, icon: ICONS.module },
          { title: 'Registrations', path: paths.dashboard.registrations.root, icon: ICONS.registration },
          { title: 'Admins', path: paths.dashboard.admins.root, icon: ICONS.admin },
          // { title: 'Logs', path: paths.dashboard.logs.root, icon: ICONS.logs },
        ],
      },
    ],
    []
  );

  return data;
}
